export default __webpack_public_path__ + "static/media/85.8b3eb66a.jpeg";